<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/1 mb-6">
      <vx-card title="">
        <h2 class="truncate">
          Assembleia Geral Ordinária
        </h2>
      </vx-card>
    </div>
    <div class="vx-col w-full md:w-1/3 mb-base">
      <vx-card title="Construtor de Ata">
        <vs-collapse type="margin">
          <vs-collapse-item>
            <div slot="header">
              Termo de Abertura
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Edital de Convocação
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Item Pauta 1
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Item Pauta 2
            </div>
            <vs-list>
              <draggable
                roup="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Item Pauta 3
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Termo de encerramento
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Comentários Gerais
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Assinaturas
            </div>
            <vs-list>
              <draggable
                group="people"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in list1"
                  :key="index"
                  :title="listItem.name"
                  :subtitle="listItem.email"
                >
                  <vs-avatar
                    slot="avatar"
                    :text="listItem.name"
                  />
                </vs-list-item>
              </draggable>
            </vs-list>
          </vs-collapse-item>
        </vs-collapse>
      </vx-card>
    </div>

    <div class="vx-col w-full md:w-2/3 mb-base">
      <vx-card
        class="ql-editor"
        title="Pré-visualização"
      >
        <canvas
          id="ata"
          style="width: 100%;"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import rasterizeHTML from 'rasterizehtml'

export default {
  components: {},
  data() {
    return {
      ata: '',
    }
  },
  mounted() {
    this.draw()
  },
  methods: {
    onEditorChange() {
      this.draw()
    },
    draw() {
      const editor = document.getElementById('editor')
      const canvas = document.getElementById('ata')
      const css = '<style>.ql-align-center{ text-align: center; } .ql-align-justify{ text-align: justify; }</style>'
      rasterizeHTML.drawHTML(this.ata + css, canvas)
      canvas.width = 800
      canvas.height = editor.offsetHeight + 50
      canvas.style.width = '100%'
      canvas.style.height = '100%'

      const ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = true
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.globalCompositeOperation = 'lighter'
      ctx.font = '48px Arial'
      ctx.fillStyle = 'gray'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText('Minuta da Ata', canvas.width / 2, canvas.height / 2)
    },
  },
}
</script>

<style></style>
